import type { CalendarDate } from '@internationalized/date';

export const formatCalendarDate = (calendarDate: CalendarDate): string => {
  return `${calendarDate.year}-${String(calendarDate.month).padStart(2, '0')}-${String(calendarDate.day).padStart(
    2,
    '0',
  )}`;
};
